import TweenLite from 'gsap'
export const hashLinkScroll = (window) => {
  const { hash } = window.location
  if (hash !== '') {
    TweenLite.to(window, 0.8, {scrollTo: hash})
  }
}
